import React, { Component } from 'react';
import { Collapse, Button, Card, CardBody, CardImg, CardImgOverlay, Col, Container, Form, Input, InputGroup, NavLink, InputGroupText, Row, FormGroup, Modal, ModalBody, ModalFooter, ModalHeader, Label, ButtonGroup } from 'reactstrap';
import Logo from '../../../assets/img/login/companyLogo.png';
import Cardbg from '../../../assets/img/login/login-bg.jpg';
import CardLogin from '../../../assets/img/login/cardLogin.png';
import '../../../css/login/login.css';
//import ForgetPassword from '../../Pages/ForgetPassword/ForgetPassword';
import '../../../components/ErrorHandler/errorHandler';
import Language from '../../../components/Language/Language';
import AxiosInstance from '../../../components/AxiosInstance/AxiosInstance';
import toast from '../../../components/ErrorHandler/toast';
import AxiosLogin from '../../../components/AxiosInstance/AxiosLogin';
import GoogleLogin from 'react-google-login';
import { Loading } from '../../../components/DataGrid/theme-sources/bootstrap4/components/loading';

let isIE = /*@cc_on!@*/false || !!document.documentMode;

const styles = {
  header: {
    height: '100vh',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    backgroundColor: '#ffffff'
  },
  content: {
    height: '100vh',
    width: '100%',
    backgroundColor: '#F6F8F9',
    color: 'white'
  },
  card: {
    display: isIE == true ? 'block' : 'flex',//handle IE browswer
    backgroundColor: 'transparent',
    border: 'none',
  },
  input: {
    height: isIE == true ? '45px' : '45px',//handle IE browswer  }
  },
  label: {
    backgroundColor: 'transparent',
    color: 'Crimson',
    fontSize: '8pt',
  }
}


class Login extends Component {

  state = { render: false }
  frgPassword = () => {
    this.setState({ render: !this.state.render })
  }

  constructor(props) {
    super(props);


    this.state = {
      fields: {},
      token: {},
      errors: {},
      modallicense: false,
      licensekey: '',
      unlockkey: '',
      licenseinfo: '',
      errorlogin: '',
      subject: '',
      message: '',
      GoogleClientID: '',
      GoogleEnabled: false,
      GoogleClientSecret: '',
      loading: false,
      btnLogin: false,
    };
    this.LoadExternalSocial = this.LoadExternalSocial.bind(this);
    this.LoadExternalSocial();
    this.handleChange = this.handleChange.bind(this);
    this.userLogin = this.userLogin.bind(this);
    this.toggleLicense = this.toggleLicense.bind(this);
    this.BindLicenseInfo = this.BindLicenseInfo.bind(this);
    this.loginSecurity = this.loginSecurity.bind(this);
    this.toggleInfoNonDisclosureAgree = this.toggleInfoNonDisclosureAgree.bind(this);
    this.BindInfoNonDisclosureAgree = this.BindInfoNonDisclosureAgree.bind(this);
    this.UpdateLicense = this.UpdateLicense.bind(this);
    this.Login = this.Login.bind(this);
    this.GoogleValidateLicense = this.GoogleValidateLicense.bind(this);
    this.GoogleLogin = this.GoogleLogin.bind(this);
    this.toggle1 = this.toggle1.bind(this);
  }

  toggle1() {
    this.setState(state => ({ collapse: !state.collapse }));
  }

  handleChange(e) {
    let fields = this.state.fields;
    fields[e.target.name] = e.target.value;
    this.setState({
      fields
    });

  }

  validateForm() {
    this.setState({
      loading: true,
      btnSave: true
    })
    let fields = this.state.fields;
    let errors = {};
    let formIsValid = true;

    if (!fields["username"]) {
      formIsValid = false;
      errors["username"] = "*This field is mandatory.";

    }

    if (!fields["password"]) {
      formIsValid = false;
      errors["password"] = "*This field is mandatory.";
    }

    this.setState({
      errors: errors,
      loading: false,
      btnSave: false
    });
    return formIsValid;
  }

  LoadExternalSocial() {

    AxiosInstance({
      method: "Get",
      errorHandle: false,
      url: "tbSYS_m_ExternalSocial/usp_tbSYS_m_ExternalSocial_SelectByEnable_V12"
    }).then(response => {
      this.setState({
        GoogleClientID: response.data[0].clientID,
        GoogleClientSecret: response.data[0].clientSecret,
        GoogleEnabled: response.data[0].enabled,
      })
    }).catch(error => {
      if (error.response != 'undefined' && error.response != undefined) {
        var message = Language.GetLanguageByID(error.response.data.errorDescription);
        toast.error(message, error.response.statusText);
      }
    });
  }

  async userLogin(e) {
    e.preventDefault();
    //this.setState({
    //  loading: true,
    //  btnLogin: true
    //})
    if (this.validateForm()) {
      await AxiosInstance({
        method: "Post",
        errorHandle: false,
        url: "tbSYS_m_Company/ValidateLicense"
      }).then(response => {
        this.setState({
          loading: false,
          btnLogin: false
        })
        this.loginSecurity();
      }).catch(error => {
        if (error.response != undefined) {
          this.setState({
            errorlogin: error.response.data.errorMessage
          });
          this.toggleLicense();
        }
      });
    }
  }


  toggleLicense() {
    this.BindLicenseInfo();
    Language.BindLanguageControl();
    this.setState({
      modallicense: !this.state.modallicense
    });

  }

  BindLicenseInfo() {
    AxiosInstance({
      method: "Get",
      url: "tbSYS_m_Company/SelectLicenseInfo"
    }).then(response => {
      this.setState({
        licensekey: response.data[0].totalLicense,
        licenseinfo: response.data[0].licenseInfo,
      });
    }).catch(error => {
      return false;
    });

  }

  loginSecurity() {
    AxiosInstance({
      method: "post",
      url: "Share_PasswordPolicy/ValidationLoginSecurity",
      data: {
        UserName: this.state.fields.username,
        UserPassword: this.state.fields.password
      }
    }).then(response => {
      if (response.data.isEnabled && response.data.url == "") {
        this.Login();
      }
      else {
        if (response.data.url == "InfoNonDisclosureAgree") {
          this.toggleInfoNonDisclosureAgree();
        }
        else if (response.data.url == "ChangePassword") {
          //this.toggleChangePassword();
        }
        else
          toast.error(response.data.errMessage, response.data.errTitle);
      }
    }).catch(error => {
      if (error.response != 'undefined' && error.response != undefined) {
        var message = Language.GetLanguageByID(error.response.data.errorDescription);
        toast.error(message, error.response.statusText);
      }
    });
  }

  toggleInfoNonDisclosureAgree() {
    this.BindInfoNonDisclosureAgree();
    this.setState({
      modalInfoNonDisclosureAgree: !this.state.modalInfoNonDisclosureAgree
    });

  }

  BindInfoNonDisclosureAgree() {
    AxiosInstance({
      method: "Get",
      url: "tbGEN_m_MEssageBoard/usp_tbGEN_m_CustomMessage_SelectByMessageNameEx"
    }).then(response => {
      this.setState({
        subject: response.data.subject,
        message: response.data.message,
      });
    }).catch(error => {
      return false;
    });
  }

  //Login
  async Login() {

    await AxiosLogin({
      method: 'post',
      url: 'Login/Login',
      errorHandle: false,
      data: {
        UserName: this.state.fields.username,
        UserPassword: this.state.fields.password
      }
    }).then(response => {
      this.setState({
        token: response.data,
        loading: true,
        btnLogin: false,
      });

      sessionStorage.setItem("NewQRadar_refreshToken", response.data.refreshToken);
      sessionStorage.setItem("NewQRadar_accessToken", response.data.accessToken);

      this.InsertToken(response.data.accessToken, response.data.refreshToken)
    }).catch(error => {
      if (error.response != 'undefined' && error.response != undefined) {
        var message = Language.GetLanguageByID(error.response.data.errorDescription);
        toast.error(message, error.response.statusText);
      }
    });


  }

  //Insert token into token table
  async InsertToken(accesstoken, refreshtoken) {
    await AxiosInstance({
      method: "post",
      url: "tbSYS_m_Token/usp_tbSYS_m_Token_Insert_V12",
      data: {
        accessToken: accesstoken,
        refreshToken: refreshtoken
      }
    }).then(response => {
      let fields = {};
      fields["username"] = "";
      fields["password"] = "";
      this.setState({ fields: fields });
      this.props.history.push('/');
    }).catch(error => {

    });
  }

  //Update License
  async UpdateLicense() {
    await AxiosInstance({
      method: "post",
      url: "tbSYS_m_Company/UpdateLicense",
      errorHandle: false,
      data: {
        TotalLicense: document.getElementById('txtunlockkey').value
      }
    }).then(response => {
      if (response.data != 'undefined') {
        this.toggleLicense();
        var message = Language.GetLanguageByID(1171.01);
        toast.success(message);
      }
    }).catch(error => {
      var message = Language.GetLanguageByID(error.response.data.message)
      toast.error(message, Language.GetLanguageByID(1704.01));
    });
  }

  SetSetting() {
    AxiosInstance({
      method: "get",
      url: "Share_PasswordPolicy/SetSetting",
      errorHandle: true,
    }).then(response => {

    }).catch(error => {

    });
  }

  async GoogleValidateLicense(googleresponse) {
    if (googleresponse.tokenId !== undefined) {
      await AxiosInstance({
        method: "Post",
        errorHandle: false,
        url: "tbSYS_m_Company/ValidateLicense"
      }).then(response => {
        this.setState({
          loading: false,
          btnLogin: false
        })
        this.GoogleLogin(googleresponse);
      }).catch(error => {
        if (error.response != undefined) {
          this.setState({
            errorlogin: error.response.data.errorMessage
          });
          this.toggleLicense();
        }
      });
    }
  }

  async GoogleLogin(googleresponse) {
    if (googleresponse.tokenId !== undefined) {
      await AxiosLogin({
        method: 'post',
        errorHandle: false,
        data: {
          UserName: "username",
          UserPassword: "password",
          Type: "Google",
          TokenID: googleresponse.tokenId,
          AccessToken: googleresponse.tokenObj.access_token,
          ClientID: this.state.GoogleClientID,
          ClientSecret: this.state.GoogleClientSecret
        },
        url: '/Login/Login',
      }).then(response => {
        this.setState({
          token: response.data
        });
        sessionStorage.setItem("NewQRadar_userImage", googleresponse.profileObj.imageUrl);
        sessionStorage.setItem("NewQRadar_refreshToken", response.data.refreshToken);
        sessionStorage.setItem("NewQRadar_accessToken", response.data.accessToken);
        this.InsertToken(response.data.accessToken, response.data.refreshToken);

      }).catch(error => {
        if (error.response != 'undefined' && error.response != undefined) {
          var message = Language.GetLanguageByID(error.response.data.errorDescription);
          toast.error(message, error.response.statusText);
        }
      });
    }
  }


  componentDidMount() {
    Language.BindLanguageControl();
    this.SetSetting();
    sessionStorage.clear();
    //sessionStorage.removeItem("NewQRadar_accessToken");
    //sessionStorage.removeItem("NewQRadar_refreshToken");
    delete AxiosInstance.defaults.headers.common["Authorization"];
  }


  render() {
    let btnGoogle;
    if (this.state.GoogleClientID !== '' && Boolean(this.state.GoogleEnabled)) {
      btnGoogle = <GoogleLogin
        clientId={this.state.GoogleClientID}
        render={renderProps => (
          <Button className="btn-google btn-brand" onClick={renderProps.onClick} ><i className="fa fa-google"></i><span>Login with Google</span></Button>
        )}
        onSuccess={this.GoogleValidateLicense}
        onFailure={this.GoogleValidateLicense}
        cookiePolicy='single_host_origin'
      />;
    }
    return (
      <div style={styles.header} >
        <div style={styles.content}>

          <div className="app flex-row align-items-center" style={{ backgroundImage: "url(" + Cardbg + ")" }}>
            <Container className="LoginContainer">
              <Row className="loginformLogo" className="justify-content-center">
                <Col lg="9" md="9" sm="12" xs="12" className="d-flex justify-content-center align-items-center">
                  <div className="Q-RadarLogo text-center">
                    <img src={Logo} className="companylogo img-responsive"></img>
                  </div>
                  <div className="Q-RadarVersion  d-none d-sm-block text-center">
                    <h3 className="card-title y-2">RedRadar</h3>
                  </div>
                </Col>
              </Row>

              <Row className="loginformDescription" className="justify-content-center">
                <div className="loginDescription">
                  <p className="card-text card-description">
                    Our proprietary RedRadar web-based system, developed by Tricor Roots Consulting and released in 2001, enables the aligning of Strategic Planning, Performance Management with Risk Management in a holistic and integrated framework.
                        </p>
                </div>
              </Row>

              <Row className="loginformRegistration" className="justify-content-center">
                <Form method="post" name="userRegistrationForm" onSubmit={this.userLogin} className="userForm">

                  <Row className="d-flex justify-content-end formtopRow-login">
                    <Language className="ddlLanguage" />
                  </Row>

                  <Row className="d-flex justify-content-center">
                    <div className="text-center text-title">
                      Log In to Your Account
                    </div>
                  </Row>

                  <Row className="d-flex justify-content-center formbuttonRow-login">
                    {btnGoogle}
                  </Row>

                  <Row className="d-flex justify-content-end formbottomRow-login">

                  </Row>

                  {this.state.loading && <Loading />}
                </Form>

              </Row>
              <Row className="d-flex justify-content-center formRow-login">
                <p className="card-text h6 d-none d-sm-block card-copyright">
                  This system is protected by Copyright Legal Acts. The use of this system is governed under the End User License Agreement.
                  2003-2016 Copyright © by Tricor Roots Consulting (471614-P). All rights reserved
                    </p>
              </Row>

            </Container>
          </div>
        </div>

        <Modal id="mdLicense" isOpen={this.state.modallicense} toggle={this.toggleLicense} ref="mdLicense" className="modal-md">
          <h5 className="modal-title"><ModalHeader toggle={this.toggleLicense} data-langid="969.01">License Request1</ModalHeader></h5>
          <ModalBody>
            <FormGroup>
              <Row className="modal-row formtopRow">
                <Col md="3">
                  <Label data-langid="773.01">License Key</Label>
                </Col>
                <Col md="9">
                  <Input type="textarea" readOnly rows="5" id="txtlockkey" placeholder="License Key" name="licensekey" value={this.state.licensekey || ''} />
                </Col>
              </Row>
            </FormGroup>
            <FormGroup>
              <Row className="modal-row formRow">
                <Col md="3">
                  <Label htmlFor="ccnumber">Unlock Key</Label>
                </Col>
                <Col md="9">
                  <Input type="textarea" rows="5" id="txtunlockkey" placeholder="Unlock Key" name="txtunlockkey" onBlur={this.handleChange} />
                </Col>
              </Row>
            </FormGroup>

            <FormGroup check>
              <Row className="modal-row formRow">
                <Label check>
                  <Input type="checkbox" name="chkAgreement" id="chkAgreement" defaultChecked={this.state.chkAgreement} onChange={this.handleCheck} />{' '}
                  I have read and agree to the
                  <span className="text-link mx-1" onClick={this.toggle1}>Term and Condition</span>
                </Label>

                <Collapse isOpen={this.state.collapse}>
                  <div className="modal-term mx-2 my-3">

                    {/* <div dangerouslySetInnerHTML={{ __html: this.state.licenseinfo }} ></div>*/}

                    <Row className="term-header d-flex justify-content-center  ">

                      <h6>Tricor Roots Consulting</h6>
                      <h4>End User License Agreement for RedRADAR</h4>

                    </Row>

                    <div className="clearfix tncontent">
                      <div className="text-left my-4 ">
                        <h5 className="font-weight-semi-bold">IMPORTANT READ CAREFULLY:</h5>

                        <div className="term-content ">
                          <h6>
                            This RedRADAR End-User License Agreement (&quot;EULA&quot;) is a legal agreement between&nbsp;<strong className="Q-R-text-secondary">Tricor Roots Consulting Sdn
                            Bhd</strong>&nbsp;(&quot;the Licensee&quot;) and&nbsp;Tricor Roots Consulting&nbsp;(&quot;the Licensor&quot;) for the (&quot;RedRADAR&quot;) product identified above, which includes
                            computer software and may include associated media, printed materials, and &quot;online&quot; or electronic documentation (&quot;SOFTWARE PRODUCT&quot;). The SOFTWARE PRODUCT also
                            includes any updates and supplements to the original SOFTWARE PRODUCT provided to you by&nbsp;Tricor Roots Consulting.&nbsp;By clicking the &quot;I Agree&quot; button below, you
                            indicate your acceptance of this agreement.
                        </h6>
                        </div>
                      </div>

                      <div className="text-left my-4 ">
                        <h5 className="font-weight-semi-bold">Software Product License</h5>
                        <div className="term-content ">
                          <div className="h6">
                            <li>The SOFTWARE PRODUCT is protected by copyright laws and international copyright treaties, as well as other intellectual property laws and treaties.</li>
                            <li>The SOFTWARE PRODUCT is licensed, not sold.</li>
                          </div>
                        </div>
                      </div>
                      <div className="text-left my-4 ">
                        <h5 className="font-weight-semi-bold">User Rights and Limitations</h5>
                        <div className="term-content ">
                          <div className="h6">
                            <ol start="1">
                              <div className="term-content-title">You may:</div>
                              <li>Use the SOFTWARE PRODUCT for a single CPU or a storage device, such as a network server for your
                                  internal data processing purposes, used only to RUN the SOFTWARE PRODUCT on your other COMPUTERS over an internal network.</li>
                              <li>The number of users that may RUN the SOFTWARE PRODUCT based on individual modules are as follows:</li>
                              <ol type="a">
                                <li>Expiry Date:1/1/2020</li>
                                <li>The users of the SOFTWARE PRODUCT must be an employee or an officer of the Licensee.</li>
                              </ol>
                              <div className="term-content-title">You shall not:</div>
                              <li>Copy, modify, transfer, assign, rent, sell or sub-license the SOFTWARE PRODUCT.</li>
                              <li>Remove any product identification, copyright notices or other notices or proprietary restrictions from the SOFTWARE PRODUCT.</li>
                              <li>Disclose or make available, directly or indirectly, the SOFTWARE PRODUCT to any person other than a permanent employee, consultant or subcontractor who is involved in the use of the SOFTWARE PRODUCT.</li>
                              <li>This Agreement does not entitle you to any new releases of the SOFTWARE PRODUCT.</li>
                            </ol>
                          </div>
                        </div>
                      </div>

                      <div className="text-left my-4 ">
                        <h5 className="font-weight-semi-bold">Limited Warranty</h5>
                        <div className="term-content ">
                          <div className="h6">
                            <ol start="1">
                              <li>You assume responsibility for the selection of the software to achieve
                                  your intended results, and for the installation, use and results obtained from the SOFTWARE PRODUCT.</li>
                              <li>The Licensor does not warrant that the operations of the SOFTWARE PRODUCT will be uninterrupted or error free. The existence of such errors shall not constitute a breach of this license.Notwithstanding this, Tricor Roots Consulting warrants that the
                                  SOFTWARE PRODUCT will perform substantially in accordance with the accompanying written materials for a period of three (3) months from the date of receipt.</li>
                              <li>The Licensor and its suppliers?entire liability and your exclusive remedy shall be, at the Licensor&rsquo;s option, either </li>
                              <ol type="a">
                                <li>return of the price paid, if any, or</li>
                                <li>repair or replacement of the SOFTWARE PRODUCT that does not meet Tricor Roots Consulting &rsquo;s Limited Warranty.</li>
                              </ol>
                              <li>In no event will the Licensor be liable to you for any damages, including lost profits, lost savings, or other incidental or consequential damages arising out of the use or inability to use the SOFTWARE PRODUCT even if the Licensor has been advised of
                                  the possibility of such damages or for any claim by any other party.</li>
                              <li>The Limited Warranty is void if failure of the SOFTWARE PRODUCT has resulted from accident, abuse, misapplication or incompatible or defective hardware. Any replacement SOFTWARE PRODUCT will be warranted for the remainder of the original warranty period or thirty (30) days, whichever is longer. Outside&nbsp;Malaysia&nbsp;, neither these remedies nor any products support services offered by Tricor Roots Consulting are
                                  available without proof of purchase from an authorised international source.</li>
                            </ol>
                          </div>
                        </div>
                      </div>
                      <div className="text-left my-4 ">
                        <h5 className="font-weight-semi-bold">Infringement of rights</h5>
                        <div className="term-content ">
                          <div className="h6">
                            <ol start="1">
                              <div className="term-content-title">You should notify us if anyone makes a claim against you that the SOFTWARE PRODUCT infringes any rights. We will, at our option:</div>
                              <li >You acknowledge that the SOFTWARE PRODUCT is the subject of copyright.</li>
                              <li >You shall not permit any acts which infringes that copyright.</li>
                              <li>You may not make copies of the SOFTWARE PRODUCT or the printed materials accompanying the SOFTWARE PRODUCT, except as otherwise expressly authorised by this license. </li>
                              <li>You shall indemnify the Licensor fully against all liabilities, costs and
                              expenses which the Licensor may incur to a third party as a result of any breach of the copyright provisions of this license or as a result of the SOFTWARE PRODUCT infringing the
                                  copyright of a of a third party, where that breach is caused or permitted to be caused by you, or any of your employees, subcontractors, agents or other party within your reasonable control.</li>
                              <li >Make the SOFTWARE PRODUCT non-infringing; or Give you a refund of the license fee paid.</li>
                              <li>This is your only remedy in the event of a claim of infringement.</li>
                            </ol>
                          </div>
                        </div>
                      </div>

                      <div className="term-footer h6 ">
                        <h6>
                          This Agreement is governed by the laws
                          of Malaysia. This agreement supercedes any other communications with respect to the SOFTWARE PRODUCT and all documentation relating to it. This Agreement may not be
                          modified except by a written addendum issued by a duly authorised representative signed by both parties. If any provision of this Agreement is held invalid, the remainder of this
                          Agreement shall continue in full force and effect.
                        </h6>
                        <ol type="1">
                          <li>Any questions concerning this Agreement should be referred to <strong className="Q-R-text-secondary"> Tricor Roots Consulting </strong></li><li>
                            You acknowledge that you have read this  agreement and by Check the checkbox and click<strong> ACTIVATE </strong>button, you accept its term and conditions.</li>
                          <li>  This agreement may only be amended by a written agreement signed by authorised representatives of both sides.</li>
                          <li>Check the checkbox and click<strong> ACTIVATE </strong>button to accept the terms and conditions of this agreement as stated above.</li>
                          <li>Click the <strong> CANCEL</strong> button tO cease using the software product.</li>
                        </ol>
                      </div>
                    </div>
                  </div>
                </Collapse>
              </Row>
            </FormGroup>
          </ModalBody>

          <ModalFooter>
            <Button color="primary" onClick={this.UpdateLicense}>Active</Button>
            <Button color="default" onClick={this.toggleLicense}>Cancel</Button>
          </ModalFooter>
        </Modal>

        <Modal id="mdInfoNonDisclosureAgree" isOpen={this.state.modalInfoNonDisclosureAgree} toggle={this.toggleInfoNonDisclosureAgree} ref="mdInfoNonDisclosureAgree" className="modal-lg" backdrop="static">
          <h3>
            <ModalHeader toggle={this.toggleInfoNonDisclosureAgree} data-langid="969.01">
              <div dangerouslySetInnerHTML={{ __html: this.state.subject }}></div>
            </ModalHeader>
          </h3>
          <ModalBody>
            <div dangerouslySetInnerHTML={{ __html: this.state.message }}></div>
          </ModalBody>

          <ModalFooter>
            <Button color="success" onClick={this.Login}>I Agree</Button>
            <Button color="outline-danger" onClick={this.toggleInfoNonDisclosureAgree}>Cancel</Button>
          </ModalFooter>
        </Modal>

      </div >
    );
  }
}

export default Login;
